<script lang="ts">
	import { get } from 'svelte/store';
	import { devices } from 'src/stores/lists/devices';
	import { real_id } from 'src/helpers/interface_helpers';
	import { routeToDeviceSettings } from 'src/stores/ui/route-to-device-settings';
	import { getRecordingById } from 'src/services/cam-cloud/recordings';
	import { setSidePanelState } from '../Sidepanel/sidepanel-helpers';
	import CameraThumbnail from '../Camera/CameraThumbnail.svelte';
	import { LabelList, LabelListV2 } from '@Shelly/shelly-design-system';
	import { RecordingMediaType } from '../Camera/types/cloud-recordings';
	import type { CloudRecording } from '../Camera/types/cloud-recordings';
	import type { EventsLogData } from 'src/types/requests/eventslog/events_log';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let event: EventsLogData;
	export let isMobile: boolean;

	$: labelListData = Object.values(event.data).filter((k: any) => !k.hidden);

	let recording: CloudRecording = null;
	let fetchId: string = null;

	$: recordingId = event?.data?.recordingId?.value as string | undefined;

	$: if (recordingId && recordingId !== fetchId) {
		fetchId = recordingId;
		recording = null;
		loadRecording(recordingId);
	}

	const loadRecording = async (id: string) => {
		try {
			recording = await getRecordingById(id);
		} catch (err) {
			console.error('Failed to fetch recording', id, err);
		}
	};

	const handleClick = () => {
		if (!recording) return;

		const deviceId = event.id;
		const allDevices = get(devices);
		const device = allDevices[deviceId] || allDevices[real_id(deviceId)];
		const id = device?.id || deviceId;

		routeToDeviceSettings.setTarget(id, 'camera_recordings', 'view', recording as any);
		setSidePanelState({ type: 'device', id, open: true });
	};

	$: overlayIcon = recording?.type === RecordingMediaType.VIDEO ? 'fas fa-play' : null;

	const addBackgroundColorToLabels = (labels: any[]) => {
		return labels.map((label: any) => ({
			...label,
			backgroundColor: '--color-1',
		}));
	};
</script>

{#if recording}
	<div
		class="width-full cursor-pointer mb-s"
		role="button"
		tabindex="0"
		on:click|stopPropagation={handleClick}
		on:keydown|stopPropagation={(e) => {
			if (e.key === 'Enter' || e.key === ' ') handleClick();
		}}
	>
		<CameraThumbnail
			deviceId={recording.mac}
			recId={recording.id}
			recDate={recording.date}
			src={recording.imageUrls?.large}
			imageSize="large"
			encrypted={!!recording.encrypted}
			size="full"
			aspectRatio="16-9"
			borderRadius="medium"
			{overlayIcon}
		>
			<div slot="topLeft" class="d-flex flex-direction-column align-items-start">
				{#if $showNewLayout}
					<LabelListV2
						a11yProps={{
							isInteractive: false,
						}}
						labelList={addBackgroundColorToLabels(labelListData)}
						size={isMobile ? 's' : 'm'}
					/>
				{:else}
					<LabelList labelList={labelListData} size={isMobile ? 's' : 'm'} />
				{/if}
			</div>
		</CameraThumbnail>
	</div>
{/if}
